module.exports = __webpack_public_path__ + "static/img/folia.4b0193b1.png";